export const initialViewsState = {
  views: [],
  availableViews: [],
  fixedViews: [],
  defaultView: null,
  activeView: null,
  showViewSelection: false,
  showSaveView: false,
  selectedViewSelection: null,
  canCreateViewForTenant: false,
  storeActiveView: true,
  storeViewKey: null,
  onDeleteView: async deletedView => ({ deletedView }),
  onAddView: async view => ({ view }),
  onChangeDefaultView: async views => ({ views }),
  onUpdateView: async (view, oldView) => ({ view, oldView }),
  onRepositionView: async repositionedViews => ({ repositionedViews }),
};

export default (state, action) => {
  switch (action.type) {
    case 'VIEWS_INITIALIZE':
      return { ...state, ...action.state };
    case 'VIEWS_SET_VIEWS':
      return {
        ...state,
        views: action.views,
        availableViews: action.views.filter(view => view.active),
      };
    case 'VIEWS_SET_AVAILABLE_VIEWS':
      return {
        ...state,
        availableViews: action.availableViews,
      };
    case 'VIEWS_SET_FIXED_VIEWS':
      return {
        ...state,
        fixedViews: action.fixedViews,
      };
    case 'VIEWS_SET_DEFAULT_VIEW':
      return { ...state, defaultView: action.defaultView };
    case 'VIEWS_SET_ACTIVE_VIEW':
      return { ...state, activeView: action.activeView };
    case 'VIEWS_SET_VIEW_SELECTION':
      return { ...state, viewSelection: action.viewSelection };
    default:
      return { ...state };
  }
};
